import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useForm } from "react-hook-form";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarTiposAcoesReguaController } from "../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import { IRelatorioReguaRequest } from "../../../../Interfaces/Automacao/Regua/RelatorioDeEnvioRegua/RelatorioDeEnvioReguaInterfaces";
import { objectEquality } from "../../../../Tools/ProcessingTools";
import RelatorioRegua from "./RelatorioRegua";

export default function RelatoriosDeRegua() {
    const todaysDate = new Date();
    //instancia um objeto date de 3 meses antes da data de hoje
    const pastDate = new Date(new Date().setMonth(todaysDate.getMonth() - 3));

    const [filter, setFilter] = useState<IRelatorioReguaRequest>(() => ({
        dtInicial: pastDate.toISOString().split("T")[0],
        dtFinal: todaysDate.toISOString().split("T")[0],
        ID_CASO_COBRANCA_REGUA_TIPO_ACAO: 0,
    }));

    const { register, handleSubmit } = useForm<IRelatorioReguaRequest>();

    function handleRelatoriosReguaFiltroFormSubmit(
        formData: IRelatorioReguaRequest
    ) {
        if (!objectEquality(formData, filter)) setFilter(formData);
    }

    return (
        <div className="card">
            <div className="card-header border-0">
                <h3 className="card-title align-items-start flex-column mb-0">
                    <span className="card-label font-weight-bolder text-dark">
                        Relatórios de Régua
                    </span>
                </h3>
            </div>

            <div className="card-body">
                <Tabs mountOnEnter unmountOnExit defaultActiveKey="#regua">
                    <Tab title="Régua" eventKey="#regua">
                        <RelatorioRegua req={filter} />
                    </Tab>
                    {/* <Tab title="Histórico" eventKey="#historico">
                        <RelatorioHistorico req={filter} />
                    </Tab> */}
                    {/* <Tab title="Pesquisa" eventKey="#pesquisa">
                        <RelatorioPesquisa req={filter}/>
                    </Tab> */}
                </Tabs>
            </div>

            <StickyToolbar>
                <form
                    className="form-group row"
                    onSubmit={handleSubmit(
                        handleRelatoriosReguaFiltroFormSubmit
                    )}
                >
                    <div className="col-12 mt-3">
                        <label>Data Inicial</label>
                        <input
                            className="form-control"
                            type="date"
                            defaultValue={filter.dtInicial}
                            name="dtInicial"
                            ref={register()}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Data Final</label>
                        <input
                            className="form-control"
                            type="date"
                            name="dtFinal"
                            defaultValue={filter.dtFinal}
                            ref={register()}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <LazySelect
                            label="Tipo de Ação"
                            className="form-control"
                            name="ID_CASO_COBRANCA_REGUA_TIPO_ACAO"
                            ref={register({
                                valueAsNumber: true,
                            })}
                            controller={ListarTiposAcoesReguaController}
                            getDS={(ta) => ta.DS_TIPO_ACAO}
                            getKeyValue={(ta) =>
                                ta.ID_CASO_COBRANCA_REGUA_TIPO_ACAO
                            }
                        >
                            <option value={0}>Todas</option>
                        </LazySelect>
                    </div>
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                </form>
            </StickyToolbar>
        </div>
    );
}
